import './App.css';
import Bounce from 'react-reveal/Bounce';

/* import imagenes */
import header from './img/mexico.webp';
import logo from './img/Logo Dj Chino-07.webp';
import chino1 from './img/chino1.webp';
import chino2 from './img/chino2.webp';
import chino3 from './img/chino3.webp';

function App() {
  return (
    <div className="App m-0 p-0">
      {/* :::::::::::::::::::::::::::::::::: HEADER ::::::::::::::::::::::::::::::::::::::::::::::::::*/}
      <div className="container-fluid m-0 p-0">
        <div className='row align-items-center justify-content-center'>
        <Bounce bottom cascade>
          {/* IMAGEN */}
          <div className="position-relative m-0 p-0" style={{backgroundImage: `url(${header})`, backgroundPosition: 'center',backgroundSize: 'cover', width: '100%', height: '15rem'}}>
            <div className="position-absolute top-100 start-50 translate-middle rounded-circle shadow" style={{backgroundColor:'white', width: '12rem', height: '12rem'}}></div> 
            
            {/* LOGO  */}           
              <div className="position-absolute top-100 start-50 translate-middle rounded-circle" style={{backgroundColor:'black', width: '10rem', height: '10rem'}}>
                <img  src={logo} alt="logo" width={'170rem'}/>                
              </div>
                          
          </div>
          </Bounce>
        </div>
      </div>

      <div className="container-fluid p-0" style={{marginTop: '8rem'}}>
        <div className='row align-items-center justify-content-center'>
          <Bounce bottom cascade>
          <h1 className="col titulos">DJ EL CHINO</h1>
          <div className="icon-bar">
            <i class="fa-brands icon fa-instagram"></i>
            <i class="fa-brands icon fa-square-facebook"></i>
            <i class="fa-brands icon fa-whatsapp"></i>
            <i class="fa-brands icon fa-twitter"></i>
            <i class="fa-brands icon fa-spotify"></i>
            <i class="fa-brands icon fa-soundcloud"></i>
          </div>
          </Bounce>
        </div>
      </div>

      {/* :::::::::::::::::::::::::::::   SECCION 1  :::::::::::::::::::::::::::::::::::::::::::::::::*/}

      <div className="container-fluid ">
        <div className='row align-items-center justify-content-center p-4' style={{backgroundColor:'black'}}>
          <Bounce bottom cascade>
          <div className='col-md-5 col-sm-12 m-3'>
          <div className="sombraNaranja" style={{backgroundImage: `url(${chino1})`, backgroundPosition: 'center',backgroundSize: 'cover', width: '30rem', height: '30rem'}}></div>
          </div>

          <div className='col-md-5 col-sm-12 m-3'>
            <p>
            El Chino, gestor cultural, productor y creador del Solar Latín Club, ha llevado sus selecciones musicales a clubs y  festivales en ciudades como Berlin, Stuttgart, Frankfurt, Colonia, Munich (Alemania), Estambul (Turquia), Bangkok,(Tailandia), Mexico DF (Mexico), Paris (Francia), Amsterdam (Holanda), Bruselas y Antwerpen (Belgica), Estocolmo (Suecia), Oslo (Noruega), San Petersburgo y Moscu (Rusia), Aveiro (Portugal), Praga (Republica Checa), Bratislava  (Eslovaquia), Atenas (Grecia), Luxemburgo y Zurich (Suiza), entre otras.
            </p>
          </div>
          </Bounce>
        </div>        
      </div>

      {/* :::::::::::::::::::::::::::::   SECCION 2  :::::::::::::::::::::::::::::::::::::::::::::::::*/}

      <div className="container-fluid ">
        <div className='row align-items-center justify-content-center p-4' style={{backgroundColor:'#EF4C05'}}>
          <Bounce bottom cascade>
          <div className='col-md-5 col-sm-12 m-3'>
            <p>
            Como compilador ha colaborado con la productora holandesa Walboomers en la serie Salsa World Series y también ha lanzado, bajo su propio sello Solar Latin Club, varios fonogramas de Salsa de diferentes orquestas del mundo. El caleño ademas acaba de lanzar el vinilo llamado El Ultimo Guiso Vol. 1 (33 RPM).
            </p>
          </div>
          
          <div className='col-md-5 col-sm-12 m-3'>
            <div className="sombraBlanca" style={{backgroundImage: `url(${chino2})`, backgroundPosition: 'center',backgroundSize: 'cover', width: '30rem', height: '30rem'}}></div>
          </div>         
          </Bounce>
        </div>        
      </div>


      {/* :::::::::::::::::::::::::::::   SECCION 3  :::::::::::::::::::::::::::::::::::::::::::::::::*/}

      <div className="container-fluid ">
        <div className='row align-items-center justify-content-center p-4' >
          <Bounce bottom cascade>
          <div className='col-md-5 col-sm-12 m-3'>
            <div className="sombraNegra" style={{backgroundImage: `url(${chino3})`, backgroundPosition: 'center',backgroundSize: 'cover', width: '30rem', height: '30rem'}}></div>            
          </div>      

          <div className='col-md-5 col-sm-12 m-3'>
            <p style={{color: 'black'}}>
            Sus sets combinan los sabores del mundo, acentuandos con los toques Latinos. Funk, Latin Jazz, Jazz, y La Musica Negra (afrocaribeña, afrobrasilera, afrobeat) en general son de su preferencia.
            </p>
            <div className='btn w-100 sombraNegra'>Leer más</div>
          </div>   
          </Bounce>
        </div>        
      </div>


      {/* :::::::::::::::::::::::::::::   SECCION 4  :::::::::::::::::::::::::::::::::::::::::::::::::*/}

      <div className="container-fluid ">
        <div className='row align-items-center justify-content-center p-4' style={{backgroundColor:'#EF4C05'}}>
          <Bounce bottom cascade>
          <div className="icon-bar-2">
            <i class="fa-brands icon-2 fa-instagram"></i>
            <i class="fa-brands icon-2 fa-square-facebook"></i>
            <i class="fa-brands icon-2 fa-whatsapp"></i>
            <i class="fa-brands icon-2 fa-twitter"></i>
            <i class="fa-brands icon-2 fa-spotify"></i>
            <i class="fa-brands icon-2 fa-soundcloud"></i>
          </div> 
          </Bounce> 
        </div>        
      </div>

      {/* :::::::::::::::::::::::::::::   SECCION 6  :::::::::::::::::::::::::::::::::::::::::::::::::*/}

      <div className="container-fluid ">
        <Bounce bottom cascade>
        <div className='row align-items-center justify-content-center p-4'>
          <h1 className="web"><span style={{color:'#EF4C05'}}>www.</span>solarlatinclub<span style={{color:'#EF4C05'}}>.com</span></h1>
        </div>
        </Bounce>
      </div>

      {/* :::::::::::::::::::::::::::::   SECCION 5  :::::::::::::::::::::::::::::::::::::::::::::::::*/}

      <div className="container-fluid ">
        <Bounce bottom cascade>
        <div className='row align-items-center justify-content-center p-4' style={{backgroundColor:'black'}}>
          <h1 className="web" style={{color:'white'}}>Descargas</h1>
          <div className="btn w-25">Fotos</div>
        </div>
        </Bounce>
      </div>


    </div>
  );
}

export default App;
